export function initMobileNavV3() {
    document.addEventListener('click', function (e) {
        var summary = e.target.closest('#mobileNavPanel summary');
        if (!summary) return;
        e.preventDefault();

        var details = summary.parentElement;
        var content = summary.nextElementSibling;
        if (!content) {
            details.open = !details.open;
            return;
        }

        var DURATION = 320;
        var EASING   = 'cubic-bezier(0.4, 0, 0.2, 1)';

        var cs     = getComputedStyle(content);
        var ptFrom = cs.paddingTop;
        var pbFrom = cs.paddingBottom;

        if (details.open) {
            var collapseAnim = content.animate(
                [{ maxHeight: content.scrollHeight + 'px', paddingTop: ptFrom, paddingBottom: pbFrom, opacity: '1', overflow: 'hidden' },
                 { maxHeight: '0px',                       paddingTop: '0px',  paddingBottom: '0px',  opacity: '0', overflow: 'hidden' }],
                { duration: DURATION, easing: EASING }
            );
            collapseAnim.onfinish = function () {
                details.open = false;
                content.style.maxHeight     = '';
                content.style.overflow      = '';
                content.style.paddingTop    = '';
                content.style.paddingBottom = '';
                content.style.opacity       = '';
            };
        } else {
            details.open = true;
            var expandHeight = content.scrollHeight;
            content.animate(
                [{ maxHeight: '0px',               paddingTop: '0px',  paddingBottom: '0px',  opacity: '0', overflow: 'hidden' },
                 { maxHeight: expandHeight + 'px', paddingTop: ptFrom, paddingBottom: pbFrom, opacity: '1', overflow: 'hidden' }],
                { duration: DURATION, easing: EASING }
            );
        }
    });
}
